<template>
    <div >
        <div class="button-box" style="margin-bottom: 30px">
        <a-button size="default" class="seachBtn" @click="onClose()" style="margin-right: 15px">返回</a-button>
        <a-button type="primary" size="default" class="seachBtn" @click="edit( )" style="margin-right: 15px"> 再次编辑 </a-button>
            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="dele()"
                    @cancel="()=>{}"
            >
                <a-button size="default" class="seachBtn"  type="danger">删除</a-button>
            </a-popconfirm>
        </div>
        <div class="formItem flex" style="font-weight: bold">
            <span>主&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题: </span>
            <p class="input">{{form.theme}}</p>
        </div>
        <div class="formItem flex">
            <span>时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间:</span>
            <p class="input">{{form.create_time_format}}</p>
        </div>
        <div class="formItem flex" style="border-bottom: 1px solid #eee;padding-bottom: 20px">
            <span>收件人:</span>
            <p class="input  " style="position: relative">

              <template v-for="(item,index) in receive_data">
                <span>{{ item.customer_name }}<{{ item.customer_email }}> </span>,
                <template v-if="item.user_emails" v-for="(items,index) in item.user_emails">
                  <span>{{ items.customer_name }}<{{ items.customer_email }}> </span>,
                </template>
              </template>

<!--                <span v-for="(item,index) in receive_data" >{{item.customer_name}}<{{item.customer_email}}> <i v-if="index!=receive_data.length-1" style="color: #000;display: inline-block;margin-right: 5px">,</i> </span>-->
            </p>
        </div>

        <div class="formItem flex">
            <div v-html="contenta"></div>
        </div>
        <div class="button-box" style="margin-top: 30px">
            <a-button size="default" class="seachBtn" @click="onClose()" style="margin-right: 15px">返回</a-button>
            <a-button type="primary" size="default" class="seachBtn" @click="edit(1)" style="margin-right: 15px"> 再次编辑 </a-button>
            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="dele()"
                    @cancel="()=>{}"
            >
                <a-button size="default" class="seachBtn"  type="danger">删除</a-button>
            </a-popconfirm>
        </div>
    </div>
</template>

<script>
    import ckeditor4 from '../Components/ckeditors'
    import {changStatus, removeById,orderList} from "../../utils/utils"
    import API from "./api";
    export default {
        name: "WriteDetails",
        data() {
            return {
                contenta: "",
                receive_data:[],
                form:{
                    customer_ids:[],
                    theme:"",
                    content:""
                },
                id: this.$route.query.id,
                next_id:""
            }
        },
        mounted() {
            this.WriteLettersAdd(this.$route.query.id)
        },
        created() {
            this.$store.state.adminleftnavnum = "/CustomerManagement/Letter"; //设置左侧导航2-2 active
        },
        methods: {
            dele(){
                    removeById(API.writeLetters.DELE,this.id).then(res => {
                        if (res == true) {
                            if(this.next_id){
                                this.WriteLettersAdd(this.next_id)
                            }else{
                                this.$router.push({path: '/CustomerManagement/Letter'})
                            }
                        }
                    })
            },
            onClose(){
                this.$router.push({path: '/CustomerManagement/Letter'})
            },
            edit(){
                let _that=this
                this.$router.push({path: '/CustomerManagement/WriteLetters', query: {ids:_that.id}})
            },
            WriteLettersAdd(id) {
                let _that=this
                API.writeLetters.ADD_DETAILS_DATA(id).then(res => {
                    this.receive_data=res.data.data.info.all_receive_data;
                  let customerIds=[]
                  let customerItemIds=[]
                  this.receive_data.map((item,index)=>{
                    customerItemIds=[]
                    if(item.user_emails&&item.user_emails.length>0){
                      item.user_emails.map((items,indexs)=>{
                        customerItemIds.push(items.id)
                      })
                      customerIds.push({id:item.a_customer_id,user_ids :customerItemIds})}else{
                      customerIds.push({id:item.a_customer_id,user_ids:[]})
                    }
                  })
                    this.form={
                        customer_ids:customerIds,
                            theme:res.data.data.info.theme,
                            content:res.data.data.info.content,
                        create_time_format:res.data.data.info.create_time_format
                    }
                    this.next_id=res.data.data.next_id
                    this.$nextTick().then(function () {
                        setTimeout(() => {
                        _that.contenta = res.data.data.info.content_text
                        }, 300)
                    })

                })
            },
        }
    }
</script>

<style scoped>
.formItem{ margin-bottom: 10px}
.formItem span i{color: #f00}
.formItem span:first-child{ width:50px;text-align: right}
.formItem .input{width: calc(100% - 55px);position: relative}
.formItem .inputa{width: calc(100% - 80px);min-height: 32px; position: relative; display: inline-block;padding: 4px 11px; color: rgba(0, 0, 0, 0.65); font-size: 14px; line-height: 1.5; background-color: #fff; border: 1px solid #d9d9d9; border-radius: 4px;}
.formItem .inputa span{margin-right:8px;display: inline-block;width: unset}
.formItem .inputa i{color: rgba(0, 0, 0, 0.3);display: inline-block;margin-left: 5px;font-weight: 400;cursor: pointer}
.writerModal>>>.ant-modal-body{padding: 15px!important;}
.error{color: #f00;position: absolute;bottom: -20px;left: 0}
</style>
